import { useEffect, useState } from "react";
import Error from "../../Layouts/Error";
import InnerHeader from "../../Layouts/InnerHeader";
import Loading from "../../Layouts/Loading";
import { toast } from 'react-toastify';
import { ShopRequest, useEditShopSettingMutation, useGetShopSettingQuery } from "../../Redux/Apis/shopApi";
import { FormImage } from "../../Components/Form/FormImage";
import { Media } from "../../Components/Media";
import { useGetAllShippingsQuery } from "../../Redux/Apis/shippingApi";
import { fa_number } from "../../utils/Persian";
import { useGetAllPaymentsQuery } from "../../Redux/Apis/paymentApi";

export default function Shop() {
    const [edit,{isLoading : isEditLoading}] = useEditShopSettingMutation()
    const {data: shippings, isLoading: isShipLoading, isSuccess: isShipSuccess} = useGetAllShippingsQuery()
    const {data: payments, isLoading: isPayLoading, isSuccess: isPaySuccess} = useGetAllPaymentsQuery()
    const [errorMsg, setErrorMsg] = useState<any>(false)

    const [formState, setFormState] = useState<ShopRequest>({
        name: "",
        banner: "",
        status: "",
    })
    
    const handleChange = ({ target: { name, value, checked },} : React.ChangeEvent<any> ) =>
        {setFormState((prev:any) => (name === "status" ? { ...prev , [name]: checked ? 'ACTIVE' : 'DEACTIVE' } : { ...prev,[name]: value } ))}

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            await edit(formState).unwrap()
            toast.success('تغییرات ذخیره شد!');
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetShopSettingQuery({})
    useEffect(() => {
        setFormState(data);
    }, [data])
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess){
        return(
        <div className="container-lg">
            <InnerHeader name="تنظیمات فروشگاه"/>
            <Media />
            {errorMsg && <div className="alert alert-danger" role="alert">
                {errorMsg}
            </div>}
            <div className="row row-cols-1 row-cols-md-3 g-4">
                <form className="col" onSubmit={onSubmit}>
                    <div className="card h-80">
                        <div className="card-header">تنظیمات کلی</div>
                        <div className="card-body">

                            <div className="form-check form-switch mb-3">
                                <input className="form-check-input" onChange={handleChange} name="status" type="checkbox" role="switch" id="status-check" defaultChecked={data.status === "ACTIVE" ? true : false} />
                                <label className="form-check-label" htmlFor="status-check">وضعیت فعالیت فروشگاه</label>
                            </div>

                            <FormImage _key='image' name='بنر فروشگاه' value={data.banner} input='banner' change={handleChange} url={data.url}/>

                            <div className="mb-3">
                                <label htmlFor="name-input" className="form-label">نام فروشگاه</label>
                                <input type="text" name="name" defaultValue={data.name} onChange={handleChange} className="form-control" id="name-input" />
                            </div>
                            
                        </div>
                        <div className="card-footer">
                            <button type="submit" disabled={isEditLoading} className="btn btn-outline-success float-end">ذخیره تغییرات</button>
                        </div>
                    </div>
                </form>
                <div className="col">
                    <div className="card">
                        <div className="card-header">روش‌های پرداخت<span className="badge text-bg-warning float-end">{payments && fa_number(payments.length)}</span></div>
                        <div className="card-body">
                            {isPayLoading && <p></p>}
                            {isPaySuccess && payments ? payments.map((row,index) => 
                            <div className="col-12 d-flex justify-content-between align-items-center p-2 border mb-2 rounded" key={index}>
                                <h6 className="my-2">{row.name}</h6>
                                <div className="text-end">
                                    <button disabled className="btn btn-sm btn-outline-primary me-2">ویرایش</button>
                                    <button disabled className="btn btn-sm btn-outline-danger">حذف</button>
                                </div>
                            </div>)
                            : 
                            <p>
                                روش پرداختی موجود نیست.
                            </p>}
                        </div>
                        <div className="card-footer ms-0">
                            <button className="btn btn-primary w-100" disabled>افزودن روش پرداخت جدید</button>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-header">روش‌های ارسال<span className="badge text-bg-warning float-end">{shippings && fa_number(shippings.length)}</span></div>
                        <div className="card-body">
                            {isShipLoading && <p></p>}
                            {isShipSuccess && shippings ? shippings.map((row,index) => 
                            <div className="col-12 d-flex justify-content-between align-items-center p-2 border mb-2 rounded" key={index}>
                                <h6 className="my-2">{row.name}</h6>
                                <div className="text-end">
                                    <button disabled className="btn btn-sm btn-outline-primary me-2">ویرایش</button>
                                    <button disabled className="btn btn-sm btn-outline-danger">حذف</button>
                                </div>
                            </div>)
                            : 
                            <p>
                                روش ارسالی موجود نیست.
                            </p>}
                        </div>
                        <div className="card-footer ms-0">
                            <button className="btn btn-primary w-100" disabled>افزودن روش ارسال جدید</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )}

    else return <></>
}